import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useBookAnalyses from 'hooks/useBookAnalyses';
import { bookAnalysesSelectors } from "features/bookAnalyses";

const BookAnalysesList = () => {
  const { getBookAnalyses } = useBookAnalyses();
  const { data, pagination } = useCustomSelector(bookAnalysesSelectors.getBookAnalysesData);
  const fetching = useCustomSelector(bookAnalysesSelectors.bookAnalysesIsFetching);

  return (
     <BaseAnalysesList
      fetchData={getBookAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <BookAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);